import Vue from 'vue';
import Vuetify from 'vuetify';
import fi from 'vuetify/lib/locale/fi';
import en from 'vuetify/lib/locale/en';
import sv from 'vuetify/lib/locale/sv';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  lang: {
    locales: {fi, en, sv},
    current: 'en',
  },
  theme: {
    options: {
      customProperties: true,
      variations: true,
    },
    dark: false,
    themes: {
      light: {
        //primary: '#caae68',
        // secondary: '#070B34',
        primary: '#0000D1',
        secondary: '#000051',
        accent: '#f0bcae',
        accent2: '#f9eee7',
        accent3: '#7194ff',
        accent4: '#f0f0f0',
        accent5: '#bebec8',
        accent6: '#818196',
        error: '#f16241',
        warning: '#ff8110',
        info: '#7194ff',
        success: '#5fbb40',
        background: '#f0f0f0',

        weakness: '#818196',
        opportunity: '#f0bcae',
        strength: '#0000d1',
      },
      dark: {
        primary: '#0000D1',
        secondary: '#000051',
        accent: '#f0bcae',
        accent2: '#f0f0f0',
        accent3: '#7194ff',
        accent4: '#efefef',
        accent5: '#bebec8',
        accent6: '#818196',

        error: '#f16241',
        warning: '#ff8110',
        info: '#7194ff',
        success: '#5fbb40',
        background: '#f0f0f0',


        weakness: '#818196',
        opportunity: '#f0bcae',
        strength: '#0000d1',
      },
    },
  },
});
